import enCA from './locales/en-CA/serviceRegistry.json';
import frCA from './locales/fr-CA/serviceRegistry.json';
import { ServiceRegistryLocale } from './types';

export const serviceRegistryResources = {
  'en-CA': { serviceRegistry: enCA },
  'fr-CA': { serviceRegistry: frCA },
} as const;

export const getServiceRegistryResource = (
  locale: ServiceRegistryLocale,
): Record<string, unknown> => serviceRegistryResources[locale].serviceRegistry;
